var exports = {
  "gP": "x61f99309--41d224--action_button",
  "lS": "x61f99309--41d224--action_button__promo",
  "Jf": "x61f99309--41d224--promo__image",
};

module.exports = exports;
